import React from "react";

export const AlertVector = () => {
	return (
		<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M16.5 7.3335C16.5 5.87481 15.9205 4.47586 14.8891 3.44441C13.8576 2.41296 12.4587 1.8335 11 1.8335C9.54131 1.8335 8.14236 2.41296 7.11091 3.44441C6.07946 4.47586 5.5 5.87481 5.5 7.3335C5.5 13.7502 2.75 15.5835 2.75 15.5835H19.25C19.25 15.5835 16.5 13.7502 16.5 7.3335Z"
				stroke="#10183D"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.5857 19.25C12.4246 19.5278 12.1933 19.7584 11.9149 19.9187C11.6366 20.079 11.3211 20.1634 10.9999 20.1634C10.6787 20.1634 10.3632 20.079 10.0849 19.9187C9.80654 19.7584 9.57522 19.5278 9.41406 19.25"
				stroke="#10183D"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
